/** Paletas Chakra v3 para fondos de avatar sin foto (deterministas por nombre). */
export const AVATAR_COLOR_PALETTES = [
  'red',
  'orange',
  'yellow',
  'green',
  'teal',
  'blue',
  'cyan',
  'purple',
  'pink',
]

/**
 * Color de avatar estable a partir del nombre (misma estética que Chakra v2).
 * @param {string} [name]
 * @returns {string}
 */
export function avatarColorPaletteFromName(name = '') {
  const s = String(name || '').trim()
  if (!s) return 'purple'
  let hash = 0
  for (let i = 0; i < s.length; i += 1) {
    hash = (hash * 31 + s.charCodeAt(i)) >>> 0
  }
  return AVATAR_COLOR_PALETTES[hash % AVATAR_COLOR_PALETTES.length]
}
